import React from 'react';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';

import { localeStrings as strings } from 'applicationConfig';

import paths from '../../../common/constants/paths';
import menuAccessTypes from '../../../common/constants/menuAccessTypes';
import { withAuth } from 'src/common/auth/Auth';



const shellMenu = [
  { component: <NavLink to={paths.home}>{strings.pageTitles.home}</NavLink>, access: menuAccessTypes.both },
  { component: <NavLink to={paths.transparencyData}>{strings.pageTitles.transparencyData}</NavLink>, access: menuAccessTypes.both },
  { component: <NavLink to={paths.reporting}>{strings.pageTitles.executionReporting}</NavLink>, access: menuAccessTypes.both },
  { component: <NavLink to={paths.documentationLoad}>{strings.pageTitles.documentation}</NavLink>, access: menuAccessTypes.both },
];

const ShellMenu = (props) => {
  const access = props.auth.isAuthenticated() ? menuAccessTypes.authenticated : menuAccessTypes.unAuthenticated;
  return (
    <nav className="shell-menu fix-widthed">
      <ul>
        {shellMenu
          .filter(item => item.access === menuAccessTypes.both || item.access === access)
          .map((item, index) => (
            <li className="link-container" key={index}>
              {item.component}
            </li>
          ))}
      </ul>
    </nav>
  );
};

export default withAuth(withRouter(ShellMenu));



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/ShellMenu.jsx